<template>
  <div class="container">
    <!-- <div class="image-zoomer" 
    style="width: 100%;
    height: 100vh; position: fixed; left: 0; top: 0; z-index: 10001;">
			<img :src="dataDetail.imageDetail" alt="" class="w-100">
		</div> -->
    <img src="@/assets/images/ornament-circle-bottom.svg" alt="bottom-image-ornament" class="home-ornament-bottom">
    <div class="product-content content-default">
      <div class="row mt-40" v-if="loadDetail">
        <div class="col-12 col-md-12 col-lg-8">
          <skeleton-loading>
            <square-skeleton :boxProperties="{
            bottom: '40px',
            width: '100%',
            height: '32px'
            }">
            </square-skeleton>

            <square-skeleton v-for="index in 4" :key="index" :boxProperties="{
            bottom: '15px',
            width: 100 - index * 5 + '%' ,
            height: '16px'
            }">
            </square-skeleton>
            

            <square-skeleton :boxProperties="{
            top: '40px',
            width: '100%',
            height: '43.8vh'
            }">
            </square-skeleton>
          </skeleton-loading>
        </div>
        <div class="col-12 col-md-12 col-lg-4">
          <skeleton-loading>
            <square-skeleton :boxProperties="{
            bottom: '15px',
            width: '100%',
            height: '160px'
            }">
            </square-skeleton>

            <square-skeleton :boxProperties="{
            bottom: '15px',
            width: '100%',
            height: '233px'
            }">
            </square-skeleton>

            <square-skeleton :boxProperties="{
            bottom: '30px',
            width: '100%',
            height: '40px'
            }">
            </square-skeleton>
          </skeleton-loading>
        </div>
      </div>

      <div class="row h-100" v-else>

        <div class="col-12 col-md-12 col-lg-8">
          <h1 class="title-default primary">
              <div class="text">{{dataDetail.title}}</div>
          </h1>
          <div class="desc mb-30" v-html="dataDetail.description">
          </div>

          <div class="wrapper-box-detail-product mobile-view show show-md hide-lg hide-xl">
            <div class="box-detail-product">
              <div class="row">
                <div class="col-4 col-md-4">
                  Category 
                </div>
                <div class="col-8 col-md-8">
                  : {{dataDetail.category[0]}} 
                </div>
              </div>

              <div class="row mt-15">
                <div class="col-4 col-md-4">
                  Price
                </div>
                <div class="col-8 col-md-8">
                  : {{dataDetail.price == 0 ? 'Free' : currency(dataDetail.price)}}
                </div>
              </div>

              <div class="row mt-15">
                <div class="col-4 col-md-4">
                  License
                </div>
                <div class="col-8 col-md-8">
                  : <a style="cursor: pointer" @click="license = !license" class="link-default no-hover">{{dataDetail.license}}</a>
                </div>
              </div>
            </div>

            <div class="box-detail-product" style="margin-top: 20px;" v-if="license">
              <span style="font-size: 12px;" v-if="dataDetail.license == 'Free Personal Use'">
                <b>Free Personal Use ,</b>
                You can use this product for free by adding attribution to your project.
                <br><br>
                <pre style="max-width: 100%; overflow-x:scroll; padding 10px 0px;">&lt;a href="{{url}}"&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;Product by jungrama<br>&lt;/a&gt;</pre>
              </span>
              <span style="font-size: 12px;" v-else>
                <b>Free Commercial Use ,</b>
                You can use this product for any of your project or brands. and you don't need to add attribution
              </span>
            </div>

            <a :href="dataDetail.urlProduct" data-gumroad-single-product="true" target="_blank" class="btn-default my-20 w-100 text-center no-shadow">Get this product</a>
          </div>
          
          <!-- <img style="border-radius: 5px;" src="@/assets/images/asd.jpg" class="w-100 mb-30" alt="image-product-detail"> -->
          <img style="border-radius: 5px;" :src="dataDetail.imageDetail" class="w-100 mb-30" alt="image-product-detail">

        </div>

        <div class="col-12 col-md-12 col-lg-4 hide hide-md">
          <div class="wrapper-box-detail-product">
            <div class="box-detail-product">
              <div class="row">
                <div class="col-12 col-md-4">
                  Category 
                </div>
                <div class="col-12 col-md-8">
                  : {{dataDetail.category[0]}} 
                </div>
              </div>

              <div class="row mt-15">
                <div class="col-12 col-md-4">
                  Price
                </div>
                <div class="col-12 col-md-8">
                  :  {{dataDetail.price == 0 ? 'Free' : currency(dataDetail.price)}}
                </div>
              </div>

              <div class="row mt-15">
                <div class="col-12 col-md-4">
                  License
                </div>
                <div class="col-12 col-md-8">
                  : <a style="cursor: pointer" @click="license = !license" class="link-default no-hover">{{dataDetail.license}}</a>
                </div>
              </div>
            </div>

            <div class="box-detail-product" style="margin-top: 20px;" v-if="license">
              <span style="font-size: 12px;" v-if="dataDetail.license == 'Free Personal Use'">
                <b>Free Personal Use ,</b>
                You can use this product for free by adding attribution to your project.
                <br><br>
                <pre style="max-width: 100%; overflow-x:scroll; padding 10px 0px;">&lt;a href="{{url}}"&gt;<br>&nbsp;&nbsp;&nbsp;&nbsp;Product by jungrama<br>&lt;/a&gt;</pre>
              </span>
              <span style="font-size: 12px;" v-else>
                <b>Free Commercial Use ,</b>
                You can use this product for any of your project or brands. and you don't need to add attribution
              </span>
            </div>

            <div class="sponsored-image mt-20">
              <a :href="dataSponsored.url" target="_blank">
                <div class="icon-sponsor"><img src="@/assets/images/icon/icon-info.svg" class="icon" alt="sponsor-icon"> Sponsored</div>
                <img v-lazy="dataSponsored.image" class="w-100 sponsor-image" alt="sponsor-image">
              </a>
            </div>

            <a :href="dataDetail.urlProduct" data-gumroad-single-product="true" target="_blank" class="btn-default mt-20 w-100 text-center no-shadow">Get this product</a>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default {
  metaInfo: {
    title: 'Product Detail - Jung Rama'
  },
	data() {
		return {
      url: null,
      loadDetail: true,
      license: false,
			dataDetail: {
        title: null,
        description: null,
        category: [],
        imageDetail: null,
        license: null,
      },
			dataSponsored: {
        image: null,
        url: null
      }
		}
	},
	methods: {
    currency(value){
      const val = parseInt(value)
      return '$' + val.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    },
		getDetailData() {
			return firebase.firestore()
				.collection('products')
				.doc(this.$route.params.slug)
				.get()
				.then(doc => {
          this.dataDetail = doc.data();
          this.getSponsor()
				})
		},

		getSponsor() {
			firebase.firestore()
				.collection('sponsored')
				.doc('sponsored-1')
				.get()
				.then(doc => {
					this.dataSponsored = doc.data();
				})
		}
	},
	mounted() {
    this.url = 'jungrama.web.app'+this.$route.fullPath
		this.loadDetail = true
    this.getDetailData()
    .then(() => {
      this.loadDetail = false
    })
	}
}
</script>